import { useState } from 'react';
import { getFullUrl } from '../utils/utils';

export const useCruiseDataApi = () => {
  const [loading, setLoading] = useState(false);

  const getCruiseData = async ({partnerId}) => {
    setLoading(true);

    const sessionToken = Math.random().toString(36).substring(2) +
        (new Date()).getTime().toString(36);

    const params = new URLSearchParams({
        sessiontoken: sessionToken,
        db: window.gon?.env,
        brand: window.gon?.current_brand,
        cruise: 'true'
    });
    
    // Conditionally add `partner_id` and `partner_autocomplete_results`
    if (partnerId) {
        params.append('partner_id', partnerId);
    }

    const endpoint = "https://y32qpijitwihjmtzbubk5lvaki0sqalh.lambda-url.us-east-1.on.aws/search";
    const apiEndpoint = `${endpoint}?${params.toString()}`;

    try {
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || `Error: ${response.status}`);
      }

      return {
        success: true,
        message: '',
        data: data
      };
    } catch (error) {
      const errorMessage = error.message === 'email is already used'
        ? error.message
        : 'Something went wrong. Please try again.';

      return { success: false, message: errorMessage };
    } finally {
      setLoading(false);
    }
  };

  return { getCruiseData, loading };
};
